var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuLight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 40,
    viewBox: "0 0 45 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 8C10 6.89547 10.8955 6 12 6H38C39.1045 6 40 6.89547 40 8C40 9.10453 39.1045 10 38 10H12C10.8955 10 10 9.10445 10 8ZM38 18H2C0.895469 18 0 18.8955 0 20C0 21.1045 0.895469 22 2 22H38C39.1045 22 40 21.1045 40 20C40 18.8955 39.1045 18 38 18ZM38 30H20C18.8955 30 18 30.8955 18 32C18 33.1045 18.8955 34 20 34H38C39.1045 34 40 33.1045 40 32C40 30.8955 39.1045 30 38 30Z",
    transform: "translate(5,5)",
    fill: "#F8FB5D",
    fillOpacity: 0.65
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8C10 6.89547 10.8955 6 12 6H38C39.1045 6 40 6.89547 40 8C40 9.10453 39.1045 10 38 10H12C10.8955 10 10 9.10445 10 8ZM38 18H2C0.895469 18 0 18.8955 0 20C0 21.1045 0.895469 22 2 22H38C39.1045 22 40 21.1045 40 20C40 18.8955 39.1045 18 38 18ZM38 30H20C18.8955 30 18 30.8955 18 32C18 33.1045 18.8955 34 20 34H38C39.1045 34 40 33.1045 40 32C40 30.8955 39.1045 30 38 30Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLight);
export default __webpack_public_path__ + "static/media/menu_light.a5e1ff464099efc762bea0e3d7465a01.svg";
export { ForwardRef as ReactComponent };